import { type InsuranceCorporateIdentity } from "../types";

export function SBHLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.2451 194.74H89.7873L158.207 263.063H88.6797L20.2451 194.74Z"
        fill="#FFB500"
      />
      <path
        d="M205.806 280.817V281.489C205.806 286.002 207.123 289.574 209.772 292.174C212.421 294.774 215.999 296.074 220.534 296.074C225.923 296.074 229.979 295.163 232.718 293.325C235.458 291.501 236.82 288.797 236.82 285.225C236.82 280.129 230.982 276.124 219.307 273.225C216.598 272.553 214.502 272.03 213.065 271.671C199.848 268.144 190.927 264.169 186.317 259.746C181.692 255.322 179.387 249.106 179.387 241.111C179.387 232.354 183.219 225.211 190.867 219.697C198.516 214.182 208.649 211.433 221.283 211.433C234.679 211.433 244.798 213.898 251.623 218.815C258.464 223.746 261.876 231.039 261.876 240.707V242.396H234.036V241.918C234.036 237.808 232.958 234.685 230.817 232.533C228.662 230.381 225.534 229.32 221.417 229.32C217.391 229.32 214.158 230.277 211.703 232.175C209.263 234.072 208.036 236.553 208.036 239.632C208.036 244.653 215.34 248.897 229.964 252.379C233.856 253.275 236.879 254.022 239.065 254.62C248.255 257.011 255.006 260.508 259.302 265.096C263.598 269.683 265.753 275.676 265.753 283.088C265.753 293.31 261.816 301.14 253.943 306.58C246.07 312.019 234.664 314.754 219.726 314.754C206.15 314.754 195.807 311.855 188.697 306.072C181.587 300.288 178.04 291.89 178.04 280.861H205.806V280.817Z"
        fill="black"
      />
      <path
        d="M281.44 313.021V213.047H318.98C334.098 213.047 345.264 215.154 352.479 219.353C359.693 223.552 363.316 230.068 363.316 238.869C363.316 244.742 361.534 249.554 357.987 253.275C354.44 256.996 349.081 259.701 341.926 261.375C350.159 262.869 356.266 265.619 360.262 269.609C364.244 273.614 366.234 278.979 366.234 285.703C366.234 294.834 362.986 301.663 356.49 306.206C349.994 310.749 340.19 313.021 327.063 313.021H281.44ZM308.248 253.574H318.98C324.952 253.574 329.323 252.663 332.077 250.825C334.831 248.986 336.223 246.132 336.223 242.247C336.223 238.541 334.771 235.761 331.882 233.908C328.979 232.055 324.683 231.129 318.98 231.129H308.248V253.574ZM308.248 294.864H318.98C325.731 294.864 330.58 293.907 333.574 291.98C336.568 290.052 338.049 286.929 338.049 282.595C338.049 278.575 336.508 275.601 333.424 273.688C330.341 271.761 325.536 270.804 318.965 270.804H308.233V294.864H308.248Z"
        fill="black"
      />
      <path
        d="M408.4 272.627V313.021H380.709V213.047H408.4V251.691H441.599V213.047H469.305V313.021H441.599V272.627H408.4Z"
        fill="black"
      />
      <path
        d="M123.54 281.101H113.123L102.555 295.731V281.101H93.2449V313.02H102.555V296.597L112.973 313.02H124.199L112.12 295.79L123.54 281.101Z"
        fill="black"
      />
      <path
        d="M146.128 295.79L157.548 281.101H147.13L136.563 295.731V281.101H127.253V313.02H136.563V296.597L146.981 313.02H158.207L146.128 295.79Z"
        fill="black"
      />
      <path
        d="M81.4649 296.538C81.4649 296.538 87.7366 295.372 87.7366 289.2C87.7366 282.983 81.3452 281.116 76.9146 281.101H60.3748V313.02H77.5882C82.3331 313.02 88.8143 310.809 88.8143 304.488C88.8143 297.24 81.4649 296.538 81.4649 296.538ZM69.5353 286.719H75.5824C77.4385 286.719 79.4592 288.378 79.4592 290.366C79.4592 292.802 77.7678 294.311 75.6872 294.311H69.5503V286.719H69.5353ZM76.271 307.192H69.5203V299.078H75.9117C77.4684 299.078 80.1926 300.229 80.1926 303.217C80.2076 306.311 77.3636 307.192 76.271 307.192Z"
        fill="black"
      />
    </svg>
  );
}

export const SBH: InsuranceCorporateIdentity = {
  id: "sbh",
  name: "SBH Hanseatische Krankenkasse",
  logo: SBHLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "sbh hanseatische krankenkasse",
  type: "statutory",
};
